<template>
  <div class="my-layout-box">
    <!-- 基本信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>基本信息</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>付款单号:  </span>
            <i class="c-code-color">{{items.Code}}</i>
          </li>
          <li>
            <span>付款状态: </span>
            <i :class="items.PaymentStatus ==0? 'c-one-color': 'c-two-color'">{{items.StatusStr}}</i>
          </li>

        </ul>
        <ul class="c-content-ul">
          <li>
            <span>申请金额:  </span>
            <i class="c-amount-color">{{items.ApplyAmount}}</i>
          </li>
           <li>
            <span>申请日期:</span>
            <i> {{items.ApplyDate | formatDate}}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>备注: </span>
            <i>{{items.Remark}}</i>
          </li>
        </ul>
      </section>
    </section>
    <!-- 公司信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>申请付款列表</span>
      </section>
      <section class="c-content-box">
        <detail-list ref="detailList" :listMap="listMap"></detail-list>

      </section>
    </section>
    <!-- 开票信息 -->
    <section class="c-box">

      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>请将以上应付款项按如下方式付至我司银行账户</span>
            <i></i>
          </li>
        </ul>

        <ul class="c-content-ul">
          <li>
            <span>公司名称: </span>
            <i>深圳市正能量供应链服务有限公司</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>1. 开户行: </span>
            <i>中国建设银行股份有限公司深圳智慧支行</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>账号: </span>
            <i>44250110379800001615</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>2. 开户行: </span>
            <i>中国交通银行股份有限公司华强支行</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>账号: </span>
            <i>43066436012018100436</i>
          </li>
        </ul>
      </section>
    </section>
  </div>
</template>
<script>
import { getPaymentApplyDetail  } from "~/api/finance";
import { itemsDetailData } from "./config";
import DetailList from "~/components/List/DetailView.vue";
const statusOption = {
    0: '未付款',
    // 1: '部分付款',
    2: '已付款'
  }
export default {
  name: "orderContractDetail",
  components: {
    DetailList
  },
  data() {
    return {
      items: {},
      listMap: itemsDetailData
    };
  },
  methods: {
    async getData() {
      const { id } = this.$route.query;
      const params = {
        Id: id
      };
      let data = await getPaymentApplyDetail(params);
       data.StatusStr = statusOption[data.PaymentStatus] || ''
      this.items = data
      this.$refs.detailList.getList(data.Lines);
    }
  },
  async created() {
    await this.getData();
  }
};
</script>


